export const enum InsightsActionTypes {
    SET_CO2_DATA = 'SET_CO2_DATA',
    SET_CO2_ERROR = 'SET_CO2_ERROR',
    SET_CO2_LOADING = 'SET_CO2_LOADING',
    SET_CO2_EXPIRATION = 'SET_CO2_EXPIRATION',
    SET_PV_INSIGHTS_DATA = 'SET_PV_INSIGHTS_DATA',
    SET_PV_INSIGHTS_ERROR = 'SET_PV_INSIGHTS_ERROR',
    SET_PV_INSIGHTS_LOADING = 'SET_PV_INSIGHTS_LOADING',
    SET_SMART_METER_INSIGHTS_DATA = 'SET_SMART_METER_INSIGHTS_DATA',
    SET_SMART_METER_INSIGHTS_ERROR = 'SET_SMART_METER_INSIGHTS_ERROR',
    SET_SMART_METER_INSIGHTS_LOADING = 'SET_SMART_METER_INSIGHTS_LOADING',
    SET_WALLBOX_LAST_SESSION_DATA = 'SET_WALLBOX_LAST_SESSION_DATA',
    SET_WALLBOX_LAST_SESSION_ERROR = 'SET_WALLBOX_LAST_SESSION_ERROR',
    SET_WALLBOX_LAST_SESSION_LOADING = 'SET_WALLBOX_LAST_SESSION_LOADING',
    SET_ELECTRIC_CAR_LAST_SESSION_DATA = 'SET_ELECTRIC_CAR_LAST_SESSION_DATA',
    SET_ELECTRIC_CAR_LAST_SESSION_ERROR = 'SET_ELECTRIC_CAR_LAST_SESSION_ERROR',
    SET_ELECTRIC_CAR_LAST_SESSION_LOADING = 'SET_ELECTRIC_CAR_LAST_SESSION_LOADING',
    SET_ELECTRIC_CAR_BONUS_DATA = 'SET_ELECTRIC_CAR_BONUS_DATA',
    SET_ELECTRIC_CAR_BONUS_ERROR = 'SET_ELECTRIC_CAR_BONUS_ERROR',
    SET_ELECTRIC_CAR_BONUS_LOADING = 'SET_ELECTRIC_CAR_BONUS_LOADING',
    SET_ELECTRIC_CAR_PV_FORECAST_DATA = 'SET_ELECTRIC_CAR_PV_FORECAST_DATA',
    SET_ELECTRIC_CAR_PV_FORECAST_ERROR = 'SET_ELECTRIC_CAR_PV_FORECAST_ERROR',
    SET_ELECTRIC_CAR_PV_FORECAST_LOADING = 'SET_ELECTRIC_CAR_PV_FORECAST_LOADING',
    SET_TOU_BATTERY_DAILY_SUMMARY_DATA = 'SET_TOU_BATTERY_DAILY_SUMMARY_DATA',
    SET_TOU_BATTERY_DAILY_SUMMARY_ERROR = 'SET_TOU_BATTERY_DAILY_SUMMARY_ERROR',
    SET_TOU_BATTERY_DAILY_SUMMARY_LOADING = 'SET_TOU_BATTERY_DAILY_SUMMARY_LOADING',
}
